export const mapListForDropdownV5 = (
  item: Record<string, string> = {},
  key = 0
) => {
  const label =
    item?.content ||
    item?.fullName ||
    item?.label ||
    item?.name ||
    item?.number ||
    item?.reason ||
    item?.refValue ||
    item?.title ||
    item?.value ||
    `${item?.firstName} ${item?.lastName}` ||
    key
  const value = item?.uuid || item?.value || null

  return {
    key: value,
    label,
    title: label,
    value
  }
}
